import styled from 'styled-components';
import DatePicker from 'antd/es/date-picker';
import Input from 'antd/es/input';

export const StyledDateInput = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  position: relative;

  .date-input-wrapper {
    display: flex;
    padding: 8px 12px;
    border-radius: 4px;
    border: ${({ theme }) => `1px solid ${theme.palette.inputBorderColor}`};
  }

  .date-input-wrapper-error {
    border-color: ${({ theme }) => theme.palette.errorColor};
  }

  .setur-picker {
    border: none;
    width: 100%;
    height: 100%;
  }

  .setur-picker-input > input {
    opacity: 0.5;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${({ theme }) => theme.palette.grey1100};
  }

  .setur-picker-focused {
    outline: none;
    box-shadow: none;
  }

  .setur-picker-suffix {
    display: none;
  }

  .date-input-title {
    color: ${({ theme }) => theme.palette.grey1100};
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }

  .date-input-label {
    opacity: 0.5;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${({ theme }) => theme.palette.grey1100};
  }

  .date-input-label-error {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${({ theme }) => theme.palette.errorColor};
  }
`;

export const StyledDateInputPicker = styled(DatePicker)``;
export const StyledInputPicker = styled(Input)``;

export const ChildDateAgeInput = styled.input`
  text-align: left;
  border: none;
  padding: 0;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.grey1100};

  &::placeholder {
    color: ${({ theme }) => theme.palette.grey800};
  }

  &[type='date']::-webkit-calendar-picker-indicator,
  &[type='date']::-webkit-inner-spin-button {
    display: none;
  }
`;

export const DateInputContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-left: 12px;
`;

export const InputErrorBox = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;

export const InputErrorText = styled.span`
  color: ${({ theme }) => theme.palette.errorColor};
`;
